import { CheckCircleFilled, SafetyOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import React, { useState } from 'react';
import Sheet from 'react-modal-sheet';
import styles from './styles.module.css';

type Props = {
  open: boolean;
  onClose: () => void;
  onConnected: (docs: string[]) => void;
};

const DigiLockerSheet: React.FC<Props> = ({ open, onClose, onConnected }) => {
  const [connecting, setConnecting] = useState(false);

  const handleConnect = () => {
    setConnecting(true);
    setTimeout(() => {
      onConnected(['RC', 'Driving License', 'PUC', 'Insurance']);
      setConnecting(false);
    }, 1500);
  };

  return (
    <Sheet
      isOpen={open}
      onClose={onClose}
      detent='content-height'
      disableScrollLocking
      style={{ zIndex: 100, maxWidth: 480, margin: 'auto' }}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
          <div className={styles.addSheet}>
            <div>
              <div className={styles.addTitle}>Connect DigiLocker</div>
              <div className={styles.addSub}>
                Pull verified govt-issued copies of your RC, DL, PUC and
                Insurance directly from DigiLocker. Encrypted and shareable
                via QR.
              </div>
            </div>

            {[
              { icon: '🚗', name: 'Registration Certificate (RC)' },
              { icon: '🪪', name: 'Driving License (DL)' },
              { icon: '💨', name: 'PUC Certificate' },
              { icon: '🛡️', name: 'Insurance Policy' },
            ].map((d) => (
              <div
                key={d.name}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '8px 0',
                  borderBottom: '1px solid #f0f2f5',
                }}
              >
                <div style={{ fontSize: 22 }}>{d.icon}</div>
                <div style={{ flex: 1, fontSize: 13, fontWeight: 500 }}>
                  {d.name}
                </div>
                <CheckCircleFilled style={{ color: '#0a8a3f' }} />
              </div>
            ))}

            <Typography.Text style={{ fontSize: 11, color: '#9ca3af' }}>
              <SafetyOutlined /> You'll be redirected to DigiLocker to authorise
              this connection. We never store your DigiLocker password.
            </Typography.Text>

            <Button
              className={styles.addBtn}
              loading={connecting}
              onClick={handleConnect}
              style={{ width: '100%', height: 44 }}
            >
              {connecting ? 'Connecting…' : 'Connect DigiLocker'}
            </Button>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={onClose} />
    </Sheet>
  );
};

export default DigiLockerSheet;
